// extracted by mini-css-extract-plugin
export default {"codeBlock":"index_codeBlock_NNaTH"};